import { render, staticRenderFns } from "./panCancer.vue?vue&type=template&id=53a83737&"
import script from "./panCancer.vue?vue&type=script&lang=js&"
export * from "./panCancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports